import React, { useState } from 'react';
import { Radio, RadioGroup, FormControl, FormControlLabel, FormLabel } from '@mui/material';
import TagUploadForm from './TagUploadForm';

import './Upload.css';

const getUploadView = (uploadType) => {
  switch (uploadType) {
    case 'tagPointType':
    case 'tagEquipmentType':
    case 'tagCreate':
    default:
      return <TagUploadForm key={uploadType} variant={uploadType} />;
  }
};

const UploadSelection = () => {
  const [uploadType, setType] = useState();
  return (
    <div className="Upload-center">
      <FormControl component="fieldset">
        <FormLabel component="legend">Select upload type:</FormLabel>
        <RadioGroup
          name="uploadType"
          color="secondary"
          value={uploadType}
          onChange={(e) => setType(e.target.value)}
        >
          <FormControlLabel value="tagCreate" control={<Radio />} label="Create or update tags" />
          <FormControlLabel
            value="tagPointType"
            control={<Radio />}
            label="Associate tags with point types"
          />
          <FormControlLabel
            value="tagEquipmentType"
            control={<Radio />}
            label="Associate tags with equipment types"
          />
        </RadioGroup>
      </FormControl>
      <hr />
      {getUploadView(uploadType)}
    </div>
  );
};

export default UploadSelection;
